import { Injectable } from '@angular/core';
import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ConfigLoaderService {

  private httpClient: HttpClient;
  private config: Config;

  constructor(handler: HttpBackend) {
    this.httpClient = new HttpClient(handler);
  }

  get ShowDebugInfo(): boolean {
    return this.config.debugInfo.showDebugInfo;
  }

  get GoogleTagManager(): GoogleTagManager {
    return this.config.googleTagManager;
  }

  get GoogleAnalytics(): GoogleAnalytics {
    return this.config.googleAnalytics;
  }

  get GoogleMaps(): GoogleMaps {
    return this.config.googleMaps;
  }

  get GoogleRecaptcha(): GoogleRecaptcha {
    return this.config.googleRecaptcha;
  }

  get firebase(): Firebase {
    return this.config.firebase;
  }

  get freeParking(): FreeParking {
    return this.config.freeParking;
  }

  public async loadConfig(): Promise<any> {
    const settings = await firstValueFrom(this.httpClient.get(environment.settingsUrl));
    this.config = settings as Config;
  }
}

export interface Config {
  debugInfo: DebugInfo,
  googleTagManager: GoogleTagManager;
  googleMaps: GoogleMaps;
  googleRecaptcha: GoogleRecaptcha;
  googleAnalytics: GoogleAnalytics;
  firebase: Firebase;
  freeParking: FreeParking;
}

export interface DebugInfo {
  showDebugInfo: boolean;
}

export interface GoogleTagManager {
  containerId: string;
}

export interface GoogleAnalytics {
  measurementId: string;
}

export interface GoogleMaps {
  key: string;
}

export interface GoogleRecaptcha {
  key: string;
}

export interface Firebase {
  apiKey: string;
  authDomain: string;
  databaseURL: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId: string;
}

export interface FreeParking {
  jsonBaseURL: string;
}
